import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import SmoothScroll from "smooth-scroll";
import "./App.css";

import SoftwareDevelopment from "./pages/SoftwareDevelopment";
import ITServices from "./pages/ITServices";
import NetworkInfrastructure from "./pages/NetworkInfrastructure";
import LandingPage from "./pages/LandingPage";
import DisasterRecovery from "./pages/DisasterRecovery";
import Projects from "./pages/Projects";
import Customers from "./pages/Customers";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const App = () => {
  return (
    <div>
      <Router>
        <Routes>
          <Route path="/" element={<LandingPage />} />

          <Route
            path="/softwareDevelopment"
            element={<SoftwareDevelopment />}
          />

          <Route path="/itServices" element={<ITServices />} />
          <Route path="/disasterRecovery" element={<DisasterRecovery />} />
          <Route
            path="/networkInfrastructure"
            element={<NetworkInfrastructure />}
          />
          <Route path="/projectsList" element={<Projects />} />
          <Route path="/customersList" element={<Customers />} />
        </Routes>
      </Router>
    </div>
  );
};

export default App;
